export default "__VITE_ASSET__kutIOViP__"